import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Wishlist/WishlistDetail/WishlistDetail.container"
    ).then((module) => ({
        default: module.WishlistDetailContainer
    }))
);
